module.exports = __webpack_public_path__ + "img/20190620162804786.8078b95a.png";